<template>
  <i v-if="isRelevant" class="tm-overlay-expired">
    <i v-if="showSelfExpiredBanner" class="-banner"> Expired </i>
  </i>
</template>

<script>
import { assetIsExpired } from '../../../../../api/asset';

export default {
  name: 'tm-overlay-expired',

  props: {
    overlay: { type: Object, required: true },
    rectangle: { type: Object, required: true },
    isFirst: { type: Boolean, required: true },
    isBanner: { type: Boolean, required: true },
  },

  computed: {
    isRelevant() {
      return assetIsExpired(this.$props.overlay);
    },

    showSelfExpiredBanner() {
      return this.isBanner && !this.isShort;
    },

    isShort() {
      return this.$props.rectangle.width < 100;
    },
  },
};
</script>

<style lang="scss">
.tm-overlay-span .tm-overlay-expired {
  position: absolute;
  top: 0;
  pointer-events: none;
  z-index: var(--tm-zOverlayExpired);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: rgba(#fff, 0.8);

  > .-banner {
    font-size: 14px;
    font-weight: 400;
    background-color: $color-orange-d;
    color: #fff;
    padding: 4px 6px;
  }
}
</style>
